"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RescheduleActivityForm = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var enums_1 = require("../../shared/enums");
var formik_1 = require("formik");
var il_box_common_1 = require("../il-box/il-box.common");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_form_label_1 = require("../il-form-label/il-form-label");
var il_date_picker_common_1 = require("../il-date-picker/il-date-picker.common");
var il_select_common_1 = require("../il-select/il-select.common");
var reschedule_activity_validation_1 = require("./reschedule-activity.validation");
var il_button_common_1 = require("../il-button/il-button.common");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
function RescheduleActivityForm(_a) {
    var _this = this;
    var _b;
    var className = _a.className, sx = _a.sx, _c = _a.startedDate, startedDate = _c === void 0 ? (0, date_fns_1.startOfDay)(new Date()) : _c, _d = _a.title, title = _d === void 0 ? (react_1.default.createElement(material_1.Typography, { sx: {
            color: 'text.secondary',
            fontSize: '0.9375rem',
            fontWeight: 'bold',
            mb: '0.55rem',
        }, variant: enums_1.TypographyVariantEnum.H6 }, "Reschedule For")) : _d, activityDescription = _a.activityDescription, averageAssignmentsPerDay = _a.averageAssignmentsPerDay, showModalHeader = _a.showModalHeader, _e = _a.dateStartYear, dateStartYear = _e === void 0 ? (0, date_fns_1.startOfDay)(new Date()) : _e, _f = _a.dateEndYear, dateEndYear = _f === void 0 ? new Date(new Date().getFullYear(), 11, 31) : _f, _g = _a.backComponent, backComponent = _g === void 0 ? (react_1.default.createElement(material_1.IconButton, { edge: "end", "aria-label": "back-action", sx: { mt: '-0.2rem', maxWidth: '1rem' }, disableRipple: true },
        react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_LEFT, size: enums_1.IconSizeEnum.SMALL }))) : _g, defaultFormValues = _a.defaultFormValues, _h = _a.textTime, textTime = _h === void 0 ? 'Started' : _h, _j = _a.dateLabel, dateLabel = _j === void 0 ? 'Remaining Course work' : _j, props = __rest(_a, ["className", "sx", "startedDate", "title", "activityDescription", "averageAssignmentsPerDay", "showModalHeader", "dateStartYear", "dateEndYear", "backComponent", "defaultFormValues", "textTime", "dateLabel"]);
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            courseId: defaultFormValues === null || defaultFormValues === void 0 ? void 0 : defaultFormValues.courseId,
            startDate: (defaultFormValues === null || defaultFormValues === void 0 ? void 0 : defaultFormValues.startDate) || (0, date_fns_1.startOfDay)(new Date()),
            endDate: (defaultFormValues === null || defaultFormValues === void 0 ? void 0 : defaultFormValues.endDate) || (0, date_fns_1.endOfDay)(new Date()),
            schoolDays: defaultFormValues === null || defaultFormValues === void 0 ? void 0 : defaultFormValues.schoolDays,
        },
        enableReinitialize: true,
        validationSchema: reschedule_activity_validation_1.RescheduleActivityValidation,
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, props.onSubmit(__assign(__assign({}, values), { courseId: defaultFormValues === null || defaultFormValues === void 0 ? void 0 : defaultFormValues.courseId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var hasAverageAssignments = averageAssignmentsPerDay !== null && averageAssignmentsPerDay !== undefined;
    return (react_1.default.createElement(formik_1.FormikProvider, { value: formik },
        react_1.default.createElement(material_1.Box, { component: formik_1.Form, onSubmit: formik.handleSubmit, sx: { height: '100%' } },
            react_1.default.createElement(material_1.Box, { className: 'il-reschedule-activity-form ' + className, sx: __assign({ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }, sx) },
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                    } },
                    showModalHeader && (react_1.default.createElement(react_1.default.Fragment, null,
                        title,
                        react_1.default.createElement(material_1.Typography, { sx: {
                                color: 'text.primary',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                            }, variant: enums_1.TypographyVariantEnum.H5 }, activityDescription))),
                    !showModalHeader && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(material_1.Box, { sx: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                mb: '1.625rem',
                            } },
                            react_1.default.createElement(material_1.Box, null, backComponent),
                            react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.H3, sx: { pt: '0.1rem' } }, activityDescription),
                            react_1.default.createElement(material_1.Box, null)))),
                    react_1.default.createElement(material_1.Typography, { sx: { fontWeight: 'normal', color: 'text.secondary' }, variant: enums_1.TypographyVariantEnum.BUTTON },
                        textTime,
                        " ",
                        (0, date_fns_1.format)(startedDate, 'MM/dd/yyyy')),
                    react_1.default.createElement(material_1.Typography, { sx: {
                            fontWeight: 'bold',
                            color: 'text.primary',
                            height: '0.9375rem',
                            mt: '1rem',
                            mb: '0.5rem',
                            display: 'table',
                        }, variant: enums_1.TypographyVariantEnum.BODY1 }, dateLabel),
                    react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { my: 0, mb: '0.5rem', gap: '0.25rem' }) },
                        react_1.default.createElement(il_form_label_1.IlFormLabel, { sx: {
                                fontSize: '0.8125rem',
                            } }, "From"),
                        react_1.default.createElement(il_date_picker_common_1.FormikFormattedDatePicker, { formik: formik, label: undefined, id: "startDate", minDate: dateStartYear, maxDate: formik.values.endDate, shouldDisableDate: il_date_picker_common_1.disableWeekends })),
                    react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { my: 0, mb: '0.5rem', gap: '0.25rem' }) },
                        react_1.default.createElement(il_form_label_1.IlFormLabel, { sx: {
                                fontSize: '0.8125rem',
                            } }, "End Date"),
                        react_1.default.createElement(il_date_picker_common_1.FormikFormattedDatePicker, { formik: formik, label: undefined, id: "endDate", dateFunction: date_fns_1.endOfDay, minDate: formik.values.startDate, maxDate: dateEndYear, shouldDisableDate: il_date_picker_common_1.disableWeekends })),
                    react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { gap: 0.5, mt: '0.5rem', mb: '1rem' }) },
                        react_1.default.createElement(il_form_label_common_1.BoldFormLabel, { sx: __assign(__assign({}, il_form_label_common_1.BoldFormLabelArgs.sx), { color: 'text.primary' }) }, "School Days"),
                        react_1.default.createElement(il_select_common_1.WeekDaySelect, { defaultSelections: (_b = formik.values) === null || _b === void 0 ? void 0 : _b.schoolDays, onChange: function (schoolDays) {
                                formik.setFieldValue('schoolDays', schoolDays);
                            }, sx: { width: '100%', flexWrap: 'wrap' }, error: formik.touched.schoolDays && formik.errors.schoolDays, childSx: __assign(__assign({}, il_select_common_1.WeekDaySelectArgs.childSx), { flexGrow: 1 }) })),
                    hasAverageAssignments && (react_1.default.createElement(material_1.Box, { sx: {
                            my: '0.5rem',
                            px: '1rem',
                            py: '1.1875rem',
                            borderWidth: '0.0625rem',
                            borderColor: 'action.disabledBackground',
                            borderStyle: 'solid',
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2rem',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(material_1.Typography, { sx: { fontSize: '0.9125rem', color: 'text.secondary' } }, "Average assignments from this courses per school day"),
                        react_1.default.createElement(material_1.Box, { sx: {
                                bgcolor: 'action.disabledBackground',
                                p: '0.5rem',
                                borderRadius: '0.375rem',
                            } },
                            react_1.default.createElement(material_1.Typography, { sx: {
                                    fontSize: '1.08125rem',
                                    color: 'text.primary',
                                    minWidth: '1.25rem',
                                    textAlign: 'center',
                                } }, averageAssignmentsPerDay))))),
                react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { justifyContent: 'center', flexDirection: 'row', flex: 0 }) },
                    react_1.default.createElement(il_button_common_1.ContainedButton, { type: enums_1.ButtonTypeEnum.SUBMIT, disabled: !formik.dirty || !formik.isValid, sx: {
                            width: '100%',
                            borderRadius: 50,
                        } }, "Save and Reschedule"))))));
}
exports.RescheduleActivityForm = RescheduleActivityForm;
